import { FillPreview, Tooltip } from '@wix/design-system';
import React from 'react';

import { SWATCH, SWATCH_TOOLTIP } from '../../data-hooks';

interface SingleColorSwatchProps {
  fill: string;
  selectedColor: string | undefined;
  onClick: (color: string) => void;
  onMouseEnter?: (color: string) => void;
  onMouseLeave?: () => void;
  className?: string;
}

export const SingleColorSwatch: React.FC<SingleColorSwatchProps> = ({
  fill,
  selectedColor,
  onClick,
  onMouseEnter,
  onMouseLeave,
  className,
}) => {
  return (
    <Tooltip
      appendTo={el => Boolean(el.getAttribute('data-hook')?.includes('ricos-portal'))}
      content={fill}
      dataHook={SWATCH_TOOLTIP}
      enterDelay={1000}
      size="small"
      placement="top"
      moveBy={{ y: 10 }}
      className={className}
    >
      <FillPreview
        selected={selectedColor?.toUpperCase() === fill.toUpperCase()}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onClick(fill);
        }}
        onMouseEnter={() => onMouseEnter?.(fill)}
        onMouseLeave={onMouseLeave}
        fill={fill}
        dataHook={SWATCH}
      />
    </Tooltip>
  );
};
